<template>
    <div class="loading-container">
      <section class="bg"></section>
      <div class="loading-text">{{ load }}%</div>
    </div>
  </template>
<script>
export default {
  data() {
    return {
      load: 0,
      interval: null,
    };
  },
  mounted() {
    this.interval = setInterval(this.blurring, 30);
  },
  methods: {
    blurring() {
      this.load++;
      if (this.load > 99) {
        clearInterval(this.interval);
      }
    },
    scale(num, in_min, in_max, out_min, out_max) {
      return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
    },
  },
  watch: {
    load(value) {
      const bg = document.querySelector('.bg');
      const loadingText = document.querySelector('.loading-text');
      loadingText.style.opacity = this.scale(value, 0, 100, 1, 0);
      bg.style.filter = `blur(${this.scale(value, 0, 100, 30, 0)}px)`;
    },
  },
};
</script>
<style scoped>

* {
  box-sizing: border-box;
}

.loading-container {
  font-family: 'Ubuntu', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  position: relative;
  z-index: 9999;
}

.bg {
  background: 
    url('@/assets/images/withbackground.webp')
    no-repeat center center / cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  filter: blur(30px);
  transition: filter 0.3s ease;
}

.loading-text {
  font-size: 50px;
  color: #fff;
  z-index: 1;
}
</style>
  